import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import BackgroundBG from "../subparts/backgrounds/BackgroundBG";

export default class Background extends Part {
  static id = 'Background';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Background';
    this.categoryEnabled = false;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "BG":
        relatedItemName = "backgroundBG";
        RelatedItemClass = BackgroundBG;
        break;
      default:
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem("Background", this);
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {

  }

}
